import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5v14a1 1 0 0 0 1.504 .864l12 -7a1 1 0 0 0 0 -1.728l-12 -7a1 1 0 0 0 -1.504 .864z","key":"svg-0"}],["path",{"d":"M20 4a1 1 0 0 1 .993 .883l.007 .117v14a1 1 0 0 1 -1.993 .117l-.007 -.117v-14a1 1 0 0 1 1 -1z","key":"svg-1"}]]

const IconPlayerSkipForwardFilled = createReactComponent('filled', 'player-skip-forward-filled', 'PlayerSkipForwardFilled', __iconNode);

export default IconPlayerSkipForwardFilled;